import * as React from 'react';
import { CLPrescriptionSelect } from './CLPrescriptionSelect.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';

const CLPrescriptionSelectContainer = ({ attributeConfig: { name , attributeOptions  } , selectClassName , eyeSideId , onChange , isDisabled  })=>{
    var ref;
    const { state , selectors  } = useCLEcommContext();
    // Get the selected prescription value (if defined) for this attribute
    const selectedValue = (ref = state.configurations[eyeSideId].prescription[name]) === null || ref === void 0 ? void 0 : ref.toString();
    // Get the UI validation state for the entire configurator
    const { invalidSubmissionsCount  } = state.configurator;
    const hasError = React.useMemo(()=>{
        const hasSubmissionError = Boolean(invalidSubmissionsCount && !isDisabled && !selectedValue);
        const hasQueryError = selectors.hasNonRecoverableErrorOnEyeside(state, eyeSideId);
        return hasSubmissionError || hasQueryError;
    }, [
        eyeSideId,
        invalidSubmissionsCount,
        isDisabled,
        selectedValue,
        state.queries
    ]);
    return /*#__PURE__*/ React.createElement(CLPrescriptionSelect, {
        name: name,
        selectClassName: selectClassName,
        eyeSideId: eyeSideId,
        options: attributeOptions,
        isDisabled: isDisabled,
        selectedValue: selectedValue,
        onChange: onChange,
        hasError: hasError
    });
};

export { CLPrescriptionSelectContainer };
//# sourceMappingURL=CLPrescriptionSelectContainer.js.map
